// Modules
import { detectShouldRun, RUN } from './modules/detectShouldRun.js';
import { getSid, storeSid } from './modules/storeSid.js';
import { handleConsent } from './modules/handleConsent.js';

// Utils
import { debug } from './modules/utils/debug.js';

// Constants
import { ACTIONS, DEBUG_CONFIG } from './config.js';

/**
 * Retrieves SID, retrieves and stores consent and detects
 * whether the library should run or not and acts in accordance.
 */
const handleSid = (handleCallback) => {
  if (window.sznIVA && window.sznIVA[DEBUG_CONFIG.name]) {
    debug('duplicate execution - terminating');
    return;
  }

  const sid = getSid();
  handleConsent(window.location.href);

  if (!sid) {
    debug('no SID or invalid SID, nothing to do');
    return;
  }

  detectShouldRun((shouldRun) => {
    let action = null;
    if (shouldRun.result === RUN) {
      action = storeSid(sid, shouldRun.reason);
    } else {
      action = ACTIONS.NO_CONSENT;
    }

    if (typeof handleCallback === 'function') {
      handleCallback(action);
    }
  });
};

export { getSid, handleSid };
